import { Injectable } from '@angular/core';
import { fromEvent, tap } from 'rxjs';
import { UserNotificationService } from '@core/modules/user-notification/user-notification.service';
import { NotificationCategory } from '@core/modules/user-notification/models/UserNotification';
import { createEffect } from '@shared/util/createEffect';

@Injectable({ providedIn: 'root' })
export class ConnectionEffect {
  public $offline = createEffect<Event>(() =>
    fromEvent(window, 'offline').pipe(
      tap(() =>
        this._userNotificationService.publishUserNotification({
          message: 'No Internet Connection!', // translate
          notificationCategory: NotificationCategory.Warning
        })
      )
    )
  );

  public $online = createEffect<Event>(() =>
    fromEvent(window, 'online').pipe(
      tap(() =>
        this._userNotificationService.publishUserNotification({
          message: 'Internet Connection is back up!', // translate
          notificationCategory: NotificationCategory.Success
        })
      )
    )
  );

  public constructor(private readonly _userNotificationService: UserNotificationService) {}
}
